export default "/images/handler.svg?d543b19a8f9fdcc8a735bd8b8233f354";